var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5834 7.50002C12.5834 8.92676 11.4268 10.0834 10 10.0834V11.5834C12.2552 11.5834 14.0834 9.75518 14.0834 7.50002H12.5834ZM10 10.0834C8.57329 10.0834 7.41669 8.92676 7.41669 7.50002H5.91669C5.91669 9.75518 7.74486 11.5834 10 11.5834V10.0834ZM7.41669 7.50002C7.41669 6.07328 8.57329 4.91669 10 4.91669V3.41669C7.74486 3.41669 5.91669 5.24486 5.91669 7.50002H7.41669ZM10 4.91669C11.4268 4.91669 12.5834 6.07328 12.5834 7.50002H14.0834C14.0834 5.24486 12.2552 3.41669 10 3.41669V4.91669ZM7.50002 14.0834H12.5V12.5834H7.50002V14.0834ZM2.41669 10C2.41669 5.81186 5.81186 2.41669 10 2.41669V0.916687C4.98343 0.916687 0.916687 4.98343 0.916687 10H2.41669ZM10 2.41669C14.1882 2.41669 17.5834 5.81186 17.5834 10H19.0834C19.0834 4.98343 15.0166 0.916687 10 0.916687V2.41669ZM17.5834 10C17.5834 12.1507 16.6891 14.0912 15.25 15.4722L16.2887 16.5544C18.0102 14.9023 19.0834 12.5758 19.0834 10H17.5834ZM15.25 15.4722C13.8868 16.7805 12.0379 17.5834 10 17.5834V19.0834C12.4404 19.0834 14.6573 18.12 16.2887 16.5544L15.25 15.4722ZM12.5 14.0834C13.7526 14.0834 14.7984 14.9756 15.0337 16.1595L16.505 15.8671C16.1329 13.9948 14.4821 12.5834 12.5 12.5834V14.0834ZM10 17.5834C7.96209 17.5834 6.11327 16.7805 4.75001 15.4722L3.71139 16.5544C5.34275 18.12 7.55967 19.0834 10 19.0834V17.5834ZM4.75001 15.4722C3.31098 14.0912 2.41669 12.1507 2.41669 10H0.916687C0.916687 12.5758 1.98983 14.9023 3.71139 16.5544L4.75001 15.4722ZM7.50002 12.5834C5.51794 12.5834 3.86718 13.9948 3.49508 15.8671L4.96631 16.1595C5.20161 14.9756 6.24745 14.0834 7.50002 14.0834V12.5834Z",
    fill: "url(#paint0_linear_1_117)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_117",
    x1: 1.66669,
    y1: 10,
    x2: 18.3334,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.9a6035821a54a3e88e80b7e87ccca503.svg";
export { ForwardRef as ReactComponent };